/** Validation mixin*/
export default {
  $_veeValidate: {
    validator: 'new'
  },
  methods: {
    random123: function(prefix) {
        //let's trick google autocomplete by constantly changing the name attribute
        //random names enforce usage of data-vv-name and data-vv-as 
        return ((prefix) ? prefix : "ran") + (new Date).getTime();
    }
  }
};
